// RecentSightings.jsx
import React, { useEffect, useState, useRef } from "react";
import axios from "../axios";

export default function RecentSightings() {
  const [sightings, setSightings] = useState([]);
  const [loading, setLoading] = useState(true);
  const prevIds = useRef(new Set());

  const fetchSightings = async () => {
    try {
      const res = await axios.get("/recent-sightings");
      const newIds = res.data.map(s => s.id);
      const diffIds = newIds.filter(id => !prevIds.current.has(id));
      prevIds.current = new Set(newIds);

      const updatedSightings = res.data.map(s => ({
        ...s,
        highlight: diffIds.includes(s.id),
      }));

      setSightings(updatedSightings);
    } catch (err) {
      console.error("新着投稿取得エラー:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSightings();
    const interval = setInterval(fetchSightings, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) return <p>読み込み中...</p>;

  return (
    <div style={{ maxWidth: "960px", margin: "0 auto", padding: "4px" }}>
      <h2 style={{ textAlign: "center", fontSize: "20px", fontWeight: "bold", marginBottom: "16px", color: "#065f46" }}>
        新着投稿(30秒毎に自動更新)
      </h2>

      <ul className="sightings-list">
        {sightings.map((s) => (
          <li
            key={s.id}
            className={`sighting-item${s.highlight ? " highlight" : ""}`}
          >
            <span className="posted-at">{s.posted_at}</span>
            <span className="depot-bus">{s.depot_short}{s.bus_number}</span>
            <span className="route">{s.route_short}</span>
            <span className="start">{s.start}{s.start_time ?? ""}</span>
          </li>
        ))}
      </ul>

      <style>
        {`
          .sightings-list {
            display: grid;
            grid-template-columns: 1fr;
            gap: 10px;
            list-style: none;
            padding: 0;
            margin: 0;
          }

          @media (min-width: 660px) {
            .sightings-list {
              grid-template-columns: 1fr 1fr;
            }
          }

          .sighting-item {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            padding: 8px 12px;
            background-color: #f0fdf4;
            border-radius: 10px;
            box-shadow: 0 2px 6px rgba(0,0,0,0.05);
            font-size: 14px;
            transition: all 0.5s ease;
          }

          /* 新着アニメーション */
          .sighting-item.highlight {
            animation: slideFade 1.5s forwards;
          }

          @keyframes slideFade {
            0% {
              transform: translateX(100%) translateY(-4px);
              opacity: 0;
              background-color: #22c55e;
              box-shadow: 0 4px 10px rgba(0,0,0,0.15);
            }
            50% {
              transform: translateX(0) translateY(-2px);
              opacity: 1;
            }
            100% {
              transform: translateX(0) translateY(0);
              background-color: #f0fdf4;
              box-shadow: 0 2px 6px rgba(0,0,0,0.05);
            }
          }

          .posted-at {
            background-color: #065f46;
            color: #fff;
            padding: 2px 6px;
            border-radius: 6px;
            font-size: 12px;
          }

          .route {
            background-color: #a7f3d0;
            padding: 2px 6px;
            border-radius: 6px;
            font-size: 12px;
          }

          .depot-bus {
            font-weight: 500;
          }

          .start {
            font-size: 14px;
          }
        `}
      </style>
    </div>
  );
}
